var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5409 14.296L17.9695 10.1633L11.5409 6.03069V14.296ZM8.32661 17.5103C7.82151 17.5103 7.38927 17.3306 7.02988 16.9712C6.66988 16.6112 6.48988 16.1786 6.48988 15.6735V4.65314C6.48988 4.14804 6.66988 3.71549 7.02988 3.35549C7.38927 2.9961 7.82151 2.81641 8.32661 2.81641H19.347C19.8521 2.81641 20.2847 2.9961 20.6447 3.35549C21.0041 3.71549 21.1838 4.14804 21.1838 4.65314V15.6735C21.1838 16.1786 21.0041 16.6112 20.6447 16.9712C20.2847 17.3306 19.8521 17.5103 19.347 17.5103H8.32661ZM4.65314 21.1838C4.14804 21.1838 3.71579 21.0041 3.35641 20.6447C2.99641 20.2847 2.81641 19.8521 2.81641 19.347V6.48988H4.65314V19.347H17.5103V21.1838H4.65314Z",
    fill: "#FFCA8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.6dec2f2f60953cb4c2f562c8c0909017.svg";
export { ForwardRef as ReactComponent };